import instance from './index';
import ExceptionHandling from './ExceptionHandling'
import { useStore, ActionTypes } from "../store";
import Toaster from '../helpers/Toaster';

export default class CashierSession {

	loginCashier(cashBalance, deviceName) {

		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/cashier_session_start';
		const formData = new FormData();
		formData.append('cashBalance', cashBalance);
		formData.append('deviceName', deviceName);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => {
				const t = new Toaster();
				t.showError(e.data.errors.email[0]);
				ExceptionHandling.HandleErrors(e);
			})
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			});

	}

	keepAliveCashierSession() {

		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/cashier_session_keep_alive';
		return instance()(
			{
				method: 'post',
				url: api
			}
		).then(res => res.data)
			.catch((e) => {
				const t = new Toaster();
				t.showError(e.data.errors.email[0]);
				ExceptionHandling.HandleErrors(e);
			})
			.finally((res) => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			});

	}

	logoutCashier() {
		const api = '/api/cashier_session_end';
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		//sign_out
		return instance()(
			{
				method: 'post',
				url: api
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			});
	}

	logoutCashierByAdmin(cashier_session_id) {
		const api = '/api/cashier_session_end';
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		
		const formData = new FormData();
		formData.append('cashier_session_id', cashier_session_id);
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		//sign_out
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			});
	}

	cashierSessionList(postObj, page) {
		const f = JSON.stringify(postObj);
			
		const api = '/api/cashier_session_list';
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		
		const formData = new FormData();
		formData.append('filters', f);
		formData.append('start', page);
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		//sign_out
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			});
		
	}

	cashierSessionTransactions(id) {
			
		const api = '/api/cashier_session_transactions';
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		//sign_out
		return instance().get(api, { params: { id: id} }).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			});
		
	}

	cashierSessionFilters() {
		
		const api = '/api/cashier_session_filters';
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		//sign_out
		return instance().get(api).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			});
	}

}